import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../../components/Delete'

const SigEventsIncidentsDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) =>
      `SigEvents Incident (#${item.id}): ${item.name} --- [DONT DELETE THESE UNLESS YOU KNOW WHAT YOU'RE DOING!]`
    }
  />
)

export default SigEventsIncidentsDelete
